/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { withLeaflet, MapLayer } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-kmz';

class GeotiffLayer extends MapLayer {
  // eslint-disable-next-line class-methods-use-this
  createLeafletElement() {
    return L.kmzLayer();
  }

  componentDidMount() {
    const { map } = this.props.leaflet;
    this.kmz = this.leafletElement.addTo(map);
    this.loadDatas(this.props.datas);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.datas !== this.props.datas) {
      this.loadDatas(this.props.datas);
    }
  }

  componentWillUnmount() {
    const { map } = this.props.leaflet;
    if (this.kmz) {
      map.removeLayer(this.kmz);
    }
    if (this.control) {
      this.control.remove();
    }
  }

  loadDatas(datas) {
    if (!datas || datas.length === 0) return;
    datas.forEach(data => {
      if (data.file) {
        const fileUrl = `${process.env.REACT_APP_FEWS_URL}/model-output/data_portal/flashflood/${data.file}`;
        const proxyUrl = `${process.env.REACT_APP_THAIWATER_URL}/proxy/kmz.php?file=${encodeURIComponent(fileUrl)}`;
        this.kmz.load(proxyUrl, data.name);
      }
    });
  }
}

// eslint-disable-next-line import/prefer-default-export
export const StormTwcLayer = withLeaflet(props => <GeotiffLayer {...props} />);
